import { CommandBarButton } from "./commandbarbutton";

export class CommandBarButtonGroup {
    buttons: CommandBarButton[] = [];
}
